document.addEventListener("DOMContentLoaded", function () {
  const menu_triggers = document.querySelectorAll("[data-trigger='kte-menu-drawer']");
  const menu = document.querySelector("kte-menu-drawer");
  const body = document.querySelector("body");

  menu_triggers.forEach((btn) => {
    btn.addEventListener("click", function () {
      menu.toggleAttribute("data-open")

      if(menu.hasAttribute('data-open')) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "visible";
      }

    })
  })

});